exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sync-notice[data-v-78fd13fc] { margin-bottom: 18px;\n}\n.sync-control[data-v-78fd13fc] { width: 100%;\n}\n.sync-note[data-v-78fd13fc] { color: var(--text-secondary, #606266); margin: 8px 0;\n}\n", ""]);

// exports
